import { apiClient } from "./client";

export type TenantPlan = "FREE" | "PRO" | "ENTERPRISE";
export type TenantStatus = "ACTIVE" | "SUSPENDED" | "ARCHIVED";

export type TenantOut = {
  id: string;
  name: string;
  slug: string;
  plan: TenantPlan;
  status: TenantStatus;
  brand_color: string | null;
  support_email: string | null;
  default_locale: string;
  audit_retention_days: number;
  /** Opt-in: when false the "declare Plan Blanc" control is hidden. */
  plan_blanc_enabled: boolean;
  created_at: string;
  updated_at: string;
  org_count: number;
  user_count: number;
  practitioner_count: number;
};

export type TenantPage = { items: TenantOut[]; total: number };

export type TenantCreate = {
  name: string;
  slug: string;
  plan?: TenantPlan;
  /** Invites the tenant's first TENANT_ADMIN. Without one nobody can administer it. */
  admin_email?: string | null;
  admin_full_name?: string | null;
};

export type TenantUpdate = {
  name?: string;
  plan?: TenantPlan;
  status?: "ACTIVE" | "SUSPENDED" | "ARCHIVED";
  brand_color?: string | null;
  support_email?: string | null;
  default_locale?: string;
  audit_retention_days?: number;
  plan_blanc_enabled?: boolean;
};

export async function listTenants(params: {
  q?: string;
  status?: TenantStatus;
  limit?: number;
  offset?: number;
} = {}): Promise<TenantPage> {
  const { data } = await apiClient.get<TenantPage>("/api/v1/admin/tenants", { params });
  return data;
}

export async function createTenant(payload: TenantCreate): Promise<TenantOut> {
  const { data } = await apiClient.post<TenantOut>("/api/v1/admin/tenants", payload);
  return data;
}

export async function updateTenant(id: string, payload: TenantUpdate): Promise<TenantOut> {
  const { data } = await apiClient.patch<TenantOut>(`/api/v1/admin/tenants/${id}`, payload);
  return data;
}


export type TenantSelfPatch = {
  name?: string;
  brand_color?: string | null;
  support_email?: string | null;
  default_locale?: string;
  audit_retention_days?: number;
  plan_blanc_enabled?: boolean;
};

export async function getMyTenant(): Promise<TenantOut> {
  const { data } = await apiClient.get<TenantOut>("/api/v1/me/tenant");
  return data;
}

export async function patchMyTenant(payload: TenantSelfPatch): Promise<TenantOut> {
  const { data } = await apiClient.patch<TenantOut>("/api/v1/me/tenant", payload);
  return data;
}
